export enum NemsisMode {
    NORMAL = 'normal',
    PRE_TEST = 'pre-test',
    TEST = 'test',
}
